import { HTMLProps } from "react";
import { inputStyles } from "./helpers";
import { clsxMerge } from "../../utils/classNameUtils";

export interface InputProps extends HTMLProps<HTMLTextAreaElement> {
  label?: string;
  infoText?: string;
  isError?: boolean;
  errorMessage?: string;
}

const TextArea = ({
  label,
  infoText,
  className,
  isError,
  errorMessage,
  disabled,
  rows = 5,
  ...props
}: InputProps) => {
  return (
    <div>
      <label
        htmlFor="input-group-1"
        className="block mb-2 text-sm font-medium text-gray700 text-left"
      >
        {label}
      </label>
      <textarea
        className={clsxMerge(
          inputStyles({
            variant: disabled ? "disabled" : isError ? "error" : "default",
          }),
          className
        )}
        disabled={disabled}
        rows={rows}
        {...props}
      />

      {Boolean(errorMessage) ? (
        <p className="text-xs text-red100">{errorMessage}</p>
      ) : Boolean(infoText) ? (
        <p className="text-xs text-gray200">{infoText}</p>
      ) : null}
    </div>
  );
};

export default TextArea;
